export default __webpack_public_path__ + "static/media/categories2.3ca291f4.png";